import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { AuditLogMaintenanceProvider } from "presentation/store/AuditLog/AuditLogMaintenanceProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { AuditLogMaintenance } from "presentation/view/section/AuditLog/AuditLogMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const AuditLogMaintenanceCont = () => {
    return <ANAInfoWrapper permission={Permission.AUDIT_LOG_MAINTENANCE}>
        <MessageBarWrapper>
            <AuditLogMaintenanceProvider>
                <GridStyles />
                <AuditLogMaintenance />
            </AuditLogMaintenanceProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default AuditLogMaintenanceCont;